var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSelectArrowDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 7,
  height: 13,
  fill: "none",
  viewBox: "0 0 7 13"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#354352",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M3.5 12.25v-11M1.25 10.25 3.5 12.5l2.25-2.25"
})));
export { SvgSelectArrowDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNyIgaGVpZ2h0PSIxMyIgdmlld0JveD0iMCAwIDcgMTMiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0zLjUgMTIuMjVMMy41IDEuMjUiIHN0cm9rZT0iIzM1NDM1MiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xLjI1IDEwLjI1TDMuNSAxMi41TDUuNzUgMTAuMjUiIHN0cm9rZT0iIzM1NDM1MiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";